import { render, staticRenderFns } from "./RightIcon.vue?vue&type=template&id=e2bc9ca8&"
import script from "./RightIcon.vue?vue&type=script&lang=ts&"
export * from "./RightIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports